import { Component, EventEmitter, OnInit, Output, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HostingService } from '../../../services/hosting.service';
import { UserTokenData } from '../../../services/auth.service';
import { AuthService } from '../../../services/auth.service';
@Component({
  selector: 'app-detail',
  imports: [CommonModule],
  templateUrl: './detail.component.html',
  styleUrl: './detail.component.css'
})
export class DetailComponent implements OnInit {
  @Output() hostingSelected = new EventEmitter<any>();
  hostings: any[] = [];
  loading: boolean = true;
  selectedHosting: any = null;
  isDropdownOpen: boolean = false;

  constructor(private hostingService: HostingService,private authService:AuthService) {
 let hostTest =[
    {
        "included_services": [
            {
                "name": "Desayuno",
                "icon": "breakfast_dining",
                "id": "f54dd540-7fc1-43f1-b5f0-0c2e6844072f",
               
            }
        ],
        "capacity": 1,
        "payment_methods": [
            {
                "name": "PSE",
                "id": "d7b827dc-f31c-4195-bf34-bcfd6e1d0a3e"
            }
        ],
        "location": {
            "country": "Colombia",
            "city": "Bogota",
            "latitude": "4.712653785527891",
            "coordinates": "4.712653785527891, -74.07582648282673",
            "full_address": "Carrera 70H, Bogota",
            "region": "",
            "longitude": "-74.07582648282673"
        },
        "extra_services": [
            {
                "name": "Tour",
                "id": "47435a44-5717-440d-86ad-04e180a4fa02",
                "cost": 10000
            }
        ],
        "createdAt": "2025-11-24T13:57:43.100Z",
        "email": "jhonguerreropinto@hotmail.es",
        "name": "PRODUCTION TEST",
        "updated_at": "2025-11-24T13:57:39.740Z",
        "user_id": "144844c8-9061-70c2-3bfe-7025fbe565fa",
        "rooms": [
            {
                "number": 1,
                "images": [
                    "https://ecoturismo-images-prod.s3.us-east-1.amazonaws.com/images/hosting/images/hosting/room_1763992608252_pnkyhbh998p.png"
                ],
                "price_per_night": 1,
                "description": "1",
                "id": "d3e16343-a630-493b-9b97-95f554f1a4dd",
                "type": "Suite",
                "floor": 1,
                "beds": 1,
                "bathrooms": 1
            }
        ],
        "images": [
            "https://ecoturismo-images-prod.s3.us-east-1.amazonaws.com/images/hosting/images/hosting/hosting-production-test-1763992584096_1763992584104_j3s5l8kjyfo.png"
        ],
        "description": "OK",
        "id": "e1850c55-5948-46b0-b374-ad8ab3493f3d",
        "phone": "313241564",
        "rule": {
            "description": "er",
            "id": "ce03c343-7739-48ac-960a-5f244631cdf7",
            "title": "ok",
            "category": "t",
            "penalty": ""
        },
        "type": "Resort"
    }]


  }

  ngOnInit(): void {


     let user:UserTokenData | null;
        user = this.authService.getUserFromToken();
        
        if(user?.['cognito:groups'] && user?.['cognito:groups'].includes('admin-hotel')){
        console.log("USEEEEEEEEEEEER",user?.['cognito:groups']);
         this.cargarAlojamientosA();
        }
    
        if(user?.['cognito:groups'] && user?.['cognito:groups'].includes('admin-recepcion')){
        console.log("USEEEEEEEEEEEER",user?.['cognito:groups']);
        this.cargarAlojamientosR();
        }
    
  }


  getHostingDisplayText(hosting: any): string {
    if (!hosting) return 'No hay alojamientos';
    return `${hosting.name} - ${hosting.location.city}  - ${hosting.type}`;
  }

   async cargarAlojamientosA() {
    try {
      this.loading = true;
      const data = await this.hostingService.getHostingsByAdminIds();
      this.hostings = data;
      
      // Automatically select the first hosting and emit it
      if (this.hostings.length > 0) {
        this.selectedHosting = this.hostings[0];
        this.hostingSelected.emit(this.hostings[0]);
      }
      
      console.log(data);
    } catch (error) {
      console.error('Error loading hostings:', error);
    } finally {
      this.loading = false;
    }
  }

  async cargarAlojamientosR() {
    try {
      this.loading = true;
      const data = await this.hostingService.getAllHostingIdRecepcion();
      this.hostings = data;
      
      // Automatically select the first hosting and emit it
      if (this.hostings.length > 0) {
        this.selectedHosting = this.hostings[0];
        this.hostingSelected.emit(this.hostings[0]);
      }
      
      console.log('HOSTING DATAAAAAAAAAAAAAA',data);
    } catch (error) {
      console.error('Error loading hostings:', error);
    } finally {
      this.loading = false;
    }
  }

  onHostingSelect(hosting: any) {
    this.selectedHosting = hosting;
    this.isDropdownOpen = false; // Close dropdown after selection
    this.hostingSelected.emit(hosting);
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  // Close dropdown when clicking outside
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    const dropdown = target.closest('.dropdown');
    if (!dropdown) {
      this.isDropdownOpen = false;
    }
  }
}